import { navigation } from '../config/company';
import './Header.css';

function Header() {
  return (
    <header className="header">
      <div className="container header__inner">
        <a className="header__brand" href="#top">
          <span className="header__logo" aria-hidden="true">
            M
          </span>
          <span className="header__brand-name">Miyin Global</span>
        </a>
        <nav className="header__nav" aria-label="Main navigation">
          {navigation.map((item) => (
            <a key={item.href} className="header__link" href={item.href}>
              {item.label}
            </a>
          ))}
        </nav>
      </div>
    </header>
  );
}

export default Header;
